const CORE_INTERACTION_OWNER = 'core';
const timersByOwner = new Map();
const flagsByOwner = new Map();

function normalizedOwner(owner = CORE_INTERACTION_OWNER) {
  return String(owner || '').trim() || CORE_INTERACTION_OWNER;
}

function ownerBucket(registry, owner, options = {}) {
  const ownerId = normalizedOwner(owner);
  let bucket = registry.get(ownerId);
  if (!bucket && options.create === true) {
    bucket = new Map();
    registry.set(ownerId, bucket);
  }
  return { ownerId, bucket: bucket || null };
}

export function clearInteractionTimer(key, owner = CORE_INTERACTION_OWNER) {
  const { ownerId, bucket } = ownerBucket(timersByOwner, owner);
  if (!bucket || !bucket.has(key)) return false;
  const handle = bucket.get(key);
  clearTimeout(handle);
  bucket.delete(key);
  if (bucket.size === 0) timersByOwner.delete(ownerId);
  return true;
}

export function clearAllInteractionTimers() {
  let cleared = false;
  for (const [owner, timers] of [...timersByOwner.entries()]) {
    for (const key of [...timers.keys()]) {
      cleared = clearInteractionTimer(key, owner) || cleared;
    }
  }
  return cleared;
}

export function setInteractionTimer(key, handle, owner = CORE_INTERACTION_OWNER) {
  clearInteractionTimer(key, owner);
  if (handle !== null && handle !== undefined) {
    ownerBucket(timersByOwner, owner, { create: true }).bucket.set(key, handle);
  }
  return handle;
}

export function setInteractionFlag(key, value = true, owner = CORE_INTERACTION_OWNER) {
  ownerBucket(flagsByOwner, owner, { create: true }).bucket.set(key, Boolean(value));
}

export function getInteractionFlag(key, owner = CORE_INTERACTION_OWNER) {
  return ownerBucket(flagsByOwner, owner).bucket?.get(key) === true;
}

export function clearInteractionFlag(key, owner = CORE_INTERACTION_OWNER) {
  const { ownerId, bucket } = ownerBucket(flagsByOwner, owner);
  if (!bucket) return false;
  const wasActive = bucket.get(key) === true;
  bucket.delete(key);
  if (bucket.size === 0) flagsByOwner.delete(ownerId);
  return wasActive;
}

export function clearInteractionFlagSoon(key, owner = CORE_INTERACTION_OWNER) {
  if (!getInteractionFlag(key, owner)) return false;
  setTimeout(() => {
    clearInteractionFlag(key, owner);
  }, 0);
  return true;
}

export function clearAllInteractionFlagsSoon() {
  let cleared = false;
  for (const [owner, flags] of [...flagsByOwner.entries()]) {
    for (const key of [...flags.keys()]) {
      cleared = clearInteractionFlagSoon(key, owner) || cleared;
    }
  }
  return cleared;
}
